@if (stepDefinitions?.length == 1) {
<section [class]="{'stepper-orientation': true, 'stepper-orientation-horizontal': !isVertical ,'stepper-orientation-vertical': isVertical }">
    <mat-card-header>
        <mat-card-title>{{firstStep.label}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mutara-form [index]='0' [layout]="layout" [stepDefinitions]="stepDefinitions" [step]="firstStep"
            [submitText]='parentLayout?.nextStep' #activeForm>
        </mutara-form>
    </mat-card-content>
</section>
}
@if(stepDefinitions?.length > 1) {
<mat-stepper [linear]='parentLayout.linear' [(selectedIndex)]='selected' [orientation]="'horizontal'"
    [class]="{'stepper-orientation': true, 'stepper-orientation-horizontal': !isVertical ,'stepper-orientation-vertical': isVertical }"
    [labelPosition]="(stepDefinitions?.length > 0 ? 'bottom' : 'end')" (selectionChange)="setStep($event)"
    role="none">
    @for(step of stepDefinitions;track step.step; let index = $index;) {
    <mat-step aria-label="{{step.label}}" [label]='step.label' [hidden]="!isStepVisible(step)"
        [optional]='!isRequired(step)'><!--[hasError]="(!!step.wasTouched || index === selected || index === 0) && step.invalidValues.length > 0"-->

        @if( isVertical ) {
        <mutara-stepper-header [stepCount]="stepDefinitions?.length" [stepLabel]="step.label" [index]="index"
            [nextStepLabel]="((index + 1) < stepDefinitions?.length) ? stepDefinitions[index + 1].label : ''"
            [isFixed]="isFixed"></mutara-stepper-header>
        }
        <mutara-form [index]='index' [stepDefinitions]='stepDefinitions' [step]='stepDefinitions[index]'
            [submitText]='parentLayout?.nextStep' [class]="{'inactive-tab-form' : selected !== index}" #activeForm>
        </mutara-form>
    </mat-step>
    }
    <ng-template matStepperIcon="edit" let-index="index">
        {{index + 1}}
    </ng-template>
    <ng-template matStepperIcon="done" let-index="index">
        {{index + 1}}
    </ng-template>
    <ng-template matStepperIcon="stepDefinitions[index].step" let-index="index">
        {{index + 1}}
    </ng-template>
</mat-stepper>
}